/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { createApi } from '@reduxjs/toolkit/query/react';

import { JimboResponse, Users, User, UserModules, VerifyPayload } from '@models';
import { baseQueryWithReauth } from '@services/refreshToken.service';

export const UsersApi = createApi({
  reducerPath: 'UsersApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Users', 'UserModules'],
  endpoints: (builder) => ({
    getAllUsers: builder.query<Users, void>({
      query: () => `/users`,
      providesTags: ['Users'],
      transformResponse: (response: JimboResponse<Users>) => response.data!,
    }),
    checkuser: builder.query<User, string>({
      query: (firebaseId: string) => `/users/checkuser/${firebaseId}`,
      providesTags: ['Users'],
      transformResponse: (response: JimboResponse<User>) => response.data!,
    }),
    createUser: builder.mutation<User, Partial<User>>({
      query: (user) => ({
        url: `/users/newuser`,
        method: 'POST',
        body: user,
      }),
      transformResponse: (response: JimboResponse<User>) => response.data!,
      invalidatesTags: ['Users'],
    }),
    updateUser: builder.mutation<User, Partial<User>>({
      query: (user) => ({
        url: `/users/updateroles/${user.id}`,
        method: 'PUT',
        body: user,
      }),
      transformResponse: (response: JimboResponse<User>) => response.data!,
      invalidatesTags: ['Users'],
    }),
    getAllModules: builder.query<UserModules, void>({
      query: () => `/users/usermodules`,
      providesTags: ['UserModules'],
      transformResponse: (response: JimboResponse<UserModules>) => response.data!,
    }),
    verifyUser: builder.mutation<JimboResponse<string>, VerifyPayload>({
      query: (verifyPayload) => ({
        url: `/users/newuser/verify2fa`,
        method: 'POST',
        body: verifyPayload,
      }),
    }),
    deleteUser: builder.mutation<User, { userId: string }>({
      query: ({ userId }) => ({
        url: `users/deleteuser/${userId}`,
        method: 'DELETE',
        body: { userId },
      }),
    }),
  }),
});

export const {
  useCheckuserQuery,
  useGetAllUsersQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useLazyCheckuserQuery,
  useGetAllModulesQuery,
  useVerifyUserMutation,
  useDeleteUserMutation,
} = UsersApi;
